// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentMedicationModel {
    static getAttributeTypeMap() {
        return EnrollmentMedicationModel.attributeTypeMap;
    }
}
EnrollmentMedicationModel.discriminator = undefined;
EnrollmentMedicationModel.additionalProperties = false;
EnrollmentMedicationModel.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentMedicationModel.js.map